// extracted by mini-css-extract-plugin
module.exports = {"root":"h5IICy","title":"mjdSCG","hint":"vqQS5o","keyboard":"_73QUTu","animated":"ng16lq","shake":"BOZgQ2","key":"o2m+j7"};